import { motion } from "framer-motion";
import { Clock } from "lucide-react";

import { useMe } from "@/hooks/useMe";

/**
 * Pagina temporanea per i ruoli non ancora abilitati alla dashboard operativa
 * (mp_viewer, mp_commerciale). SPEC-A: questi ruoli non vedono né la dashboard
 * operativa né la vetrina di progetto finché non verranno configurati.
 */
export function NonDisponibilePage() {
  const { data: me } = useMe();
  const nome = me?.nome_completo?.split(" ")[0];

  return (
    <div className="mx-auto flex min-h-[60vh] max-w-xl flex-col items-center justify-center px-6 text-center">
      <motion.div
        initial={{ opacity: 0, y: 6 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.25, ease: "easeOut" }}
        className="space-y-4"
      >
        <div className="mx-auto flex size-14 items-center justify-center rounded-full bg-brand-50 text-brand-700">
          <Clock className="size-6" aria-hidden="true" />
        </div>
        <h1 className="text-2xl font-semibold">
          {nome ? `Ciao ${nome}, ` : ""}la tua area è in allestimento
        </h1>
        <p className="text-sm text-muted-foreground">
          Questa sezione della piattaforma Mister Pet non è ancora disponibile per
          il tuo profilo. Sarà attivata a breve: ti avviseremo appena pronta.
        </p>
      </motion.div>
    </div>
  );
}
